import ko from "knockout";
import register from "flow/knockout/register";

declare global {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface KnockoutExtenders {
        numeric(target: KnockoutObservable<number>, precision: number): KnockoutObservable<number>;
    }
}

// http://knockoutjs.com/documentation/extenders.html
register.registerKnockoutExtension("numeric", function (target: KnockoutObservable<number>, precision: number) {
    //create a writeable computed observable to intercept writes to our observable
    const result = ko
        .computed({
            read: target, //always return the original observables value
            write(newValue: any) {
                const current = target();
                const roundingMultiplier = Math.pow(10, precision);
                const newValueAsNum = isNaN(newValue) ? 0 : +newValue; // Unary plus
                const valueToWrite = Math.round(newValueAsNum * roundingMultiplier) / roundingMultiplier;

                //only write if it changed
                if (valueToWrite !== current) {
                    target(valueToWrite);
                } else {
                    //if the rounded value is the same, but a different value was written, force a notification for the current field
                    if (newValue !== current) {
                        target.notifySubscribers(valueToWrite);
                    }
                }
            }
        })
        .extend({
            notify: "always"
        });

    // Needed to work with other extensions that add fields and functions to the observable.
    const templateObs = ko.observable() as any;
    const targetAny = target as any;
    const resultAny = result as any;
    for (const property in target) {
        if (templateObs[property] === undefined) {
            if (typeof targetAny[property] === "function") {
                if (ko.isObservable(targetAny[property]) || ko.isComputed(targetAny[property])) {
                    resultAny[property] = targetAny[property];
                } else {
                    resultAny[property] = function (...params: any[]) {
                        return targetAny[property].call(target, ...params);
                    };
                }
            } else {
                resultAny[property] = targetAny[property];
            }
        }
    }

    //initialize with current value to make sure it is rounded appropriately
    result(target());

    //return the new computed observable
    return result;
});
